import { render, staticRenderFns } from "./view-reset-password.vue?vue&type=template&id=b43fb7d4&scoped=true&"
import script from "./view-reset-password.vue?vue&type=script&lang=js&"
export * from "./view-reset-password.vue?vue&type=script&lang=js&"
import style0 from "./view-reset-password.vue?vue&type=style&index=0&id=b43fb7d4&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b43fb7d4",
  null
  
)

export default component.exports